export default __webpack_public_path__ + "static/media/download.ad61519e.jfif";